import isEmail from 'validator/lib/isEmail';

const hasEmoji = (input: string) => input.match(/\p{Extended_Pictographic}/u);

// Don't support non-ascii characters (those that have been converted to "xn--")
const isValidEmail = (input: string) => isEmail(input) && !hasEmoji(input) && !/@xn--/.test(input);

export default isValidEmail;
